module.exports = __webpack_public_path__ + "images/locator/my_location-c05a1c68.svg";